import { Card, Space, Table } from "@arco-design/web-react";
import { SOFulfillmentAdd } from "./so-fulfillment-add";
import { SOFulfillmentInfo } from "./so-fulfillment-info";
import { SOFulfillmentEdit } from "./so-fulfillment-edit";
import { FulfillmentStatusDef } from "@/enums/sales";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { SOFulfillmentAPI } from "@/apis/sales";
import SaleOrderLink from "@/components/SaleOrderLink";
import _ from "lodash";

export const SOFulfillment = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [status, setStatus] = useState();

    const getList = useCallback(async () => {
        const values = await SOFulfillmentAPI.query(page, { status: status });
        setData(values.records);
        setTotal(values.total);
    }, [page, status]);

    useEffect(() => {
        getList();
    }, [getList]);

    return (
        <Card title="SO Fulfillments" extra={
            <Space>
                <EnumSelect enumObj={FulfillmentStatusDef} allowAll style={{ width: 200 }}
                    placeholder="Status"
                    onChange={(val) => {
                        setStatus(val);
                    }} />
            </Space>
        }>
            <Table rowKey="id" columns={[
                {
                    title: "SO Fulfillment#",
                    render: (col, record) => {
                        return <Link to={"/workspace/sales/so-fulfillment/" + record.id}>{record.soFulfillmentNo}</Link>
                    }
                },
                { title: "Customer", dataIndex: "customerName" },
                { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={FulfillmentStatusDef} value={record.status} /> },
                {
                    title: "Pick Order#",
                    render: (col, record) => _.join(_.map(record.pickOrders, "pickOrderNo"), ", ")
                },
                { title: "SO#", render: (col, record) => <SaleOrderLink soId={record.soId}>{record.soNo}</SaleOrderLink> },
                { title: "SO Due Date", dataIndex: "soDueDate" },
                { title: "SO Creation Date", dataIndex: "soCreateDate" },
                { title: "Fulfillment Date", dataIndex: "fulfillmentDate" },
            ]} data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)} />
        </Card>
    )
}

SOFulfillment.Add = SOFulfillmentAdd;
SOFulfillment.Info = SOFulfillmentInfo;
SOFulfillment.Edit = SOFulfillmentEdit;
